import { render, staticRenderFns } from "./fleg-comp-determinacion-de-las-coutas-obrero-patronales-mensuales.vue?vue&type=template&id=5a9e33cd&lang=html&"
import script from "./fleg-comp-determinacion-de-las-coutas-obrero-patronales-mensuales.vue?vue&type=script&lang=js&"
export * from "./fleg-comp-determinacion-de-las-coutas-obrero-patronales-mensuales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports